import { useEffect, useState } from "react"
import { DepartmentType, PaginationType } from "@/types"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { getDepartment } from "@/lib/api/billing"
import { DataTable } from "@/components/data-table"
import { Header } from "@/components/header"
import { departmentsColumns } from "@/components/table/columns/departments-columns"
import { ExportOperationModal } from "@/components/table/operations/export-operations"

import AddDepartmentPage from "./add"

export const Route = createFileRoute("/_home/user-role-management/department/")(
  {
    component: DepartmentPage,
  },
)

function DepartmentPage() {
  const [showExportModal, setShowExportModal] = useState<boolean>(false)
  const [defaultPage, setDefaultPage] = useState<number>(10)
  const [page, setPage] = useState<number>(1)
  const [search, setSearch] = useState<string>("")

  const [nextPageUrl, setNextPageUrl] = useState<string | null>(null)
  const [prevPageUrl, setPrevPageUrl] = useState<string | null>(null)

  const {
    data: departmentDetails,
    isError,
    isLoading,
  } = useQuery<PaginationType<DepartmentType>>({
    queryKey: ["departmentDetails", defaultPage, page, search],
    queryFn: () => getDepartment(defaultPage, page, search),
  })

  useEffect(() => {
    if (departmentDetails) {
      setNextPageUrl(departmentDetails.next)
      setPrevPageUrl(departmentDetails.previous)
    }
  }, [departmentDetails])

  return (
    <div className="space-y-4 p-4">
      <Header>Department</Header>
      <DataTable
        columns={departmentsColumns}
        data={departmentDetails?.results ?? []}
        search={{
          label: "Departments",
          value: search,
          onChange: setSearch,
        }}
        isLoading={isLoading}
        isError={isError}
        defaultPage={defaultPage}
        setDefaultPage={setDefaultPage}
        nextPageUrl={nextPageUrl}
        prevPageUrl={prevPageUrl}
        page={page}
        setPage={setPage}
        totalCount={departmentDetails?.count}
      >
        <div className="flex w-full justify-end gap-1">
          <AddDepartmentPage />
          <ExportOperationModal
            tableData={departmentDetails?.results ?? [{}]}
            fileName="Departments"
            showExportModal={showExportModal}
            setShowExportModal={setShowExportModal}
          />
        </div>
      </DataTable>
    </div>
  )
}
